<template>
  <div class="album">
    <div class="header">
      <div v-if="$route.path == '/user/album'" class="title-box active">
        <span class="title">ALBUM</span>
      </div>
      <div v-else class="title-box active">
        <div class="back-arrow">
          <router-link :to="{ path: '/user/album' }"
            ><img src="../../assets/images/user_dashboard/back_arrow.png"
          /></router-link>
        </div>
        <span class="title">PICTURES</span>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'album'
}
</script>

<style lang="scss" scoped>
.album {
  .header {
    display: flex;
    .title-box {
      position: relative;
      width: 100%;
      height: 60px;
      background-color: #ffffff;
      border: solid 1px #e7e7e7;
      text-align: center;
      &:nth-child(2) {
        border-left: 0;
      }
      .title {
        line-height: 60px;
        font-size: 16px;
        letter-spacing: 1px;
        text-align: center;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        color: #000000;
      }

      &.active {
        span {
          font-weight: 600;
          color: #ab08b6;
        }
        border-bottom: 0;
      }

      .back-arrow {
        width: 20px;
        height: 15px;
        position: absolute;
        margin: auto;
        top: 0;
        left: 20px;
        /* right: 0; */
        bottom: 0;
      }
    }
  }
}
</style>
